export default [
  {
    id: 'terms-of-use',
    text: 'Terms of Use',
    link: 'https://inwin.online/static/media/InWin_T&C_v1.3.3622541f.pdf',
  },
  { id: 'rate-us', text: 'Rate Us', link: '' },
  { id: 'contact-us', text: 'Contact Us', link: 'mailto:info@inwin.online' },
]
